import { useEffect, useState } from "react";
import MenuLine from "../MenuLine/MenuLine";
import { ChevronDown } from "lucide-react";
import { slugify } from "../../utils/string";
import { useTranslation } from "react-i18next";

export function MenuItemsGroup({
   group,
   navWidth,
   pageSelected,
   backup,
   isCollapsed,
   groupIndex,
   ...props
}) {
   const [isExpanded, setIsExpanded] = useState(true);
   const { t } = useTranslation();

   useEffect(() => {
      const storedIsExpanded = localStorage.getItem(`@BRV:menu-group-expanded:${slugify(group.groupLabel)}`);
      if (storedIsExpanded != null) {
         setIsExpanded(storedIsExpanded === 'true');
      }
   }, []);

   function toggleExpanded() {
      setIsExpanded(!isExpanded);
      localStorage.setItem(`@BRV:menu-group-expanded:${slugify(group.groupLabel)}`, !isExpanded);
   }

   return (
      <div style={{ marginTop: isCollapsed ? '10px' : 0, padding: '0 8px' }}>
         {!isCollapsed && group.groupLabel &&
            <button
               type="button"
               className="muted-sm menu-group-title"
               onClick={toggleExpanded}>
               {t(group.groupLabel)}
               <ChevronDown size={12} className={`transition-transform duration-200 ${!isExpanded ? '-rotate-90' : ''}`} />
            </button>
         }
         <div className={`relative flex flex-col gap-1! ${!isExpanded ? 'opacity-0 h-0 overflow-hidden' : ''} transition-all duration-300 ease-in-out`}>
            {group.items.map((menu, index) => (
               <MenuLine
                  key={index}
                  index={null}
                  groupIndex={groupIndex + index + 1}
                  title={t(menu.title)}
                  route={menu.route}
                  routes={menu.routes}
                  submenu={menu.submenu}
                  handleClick={(route) => props.handleNavigation(route ?? menu.route)}
                  icon={menu.icon}
                  navWidth={navWidth}
                  pageSelected={pageSelected}
                  backup={backup}
                  disabled={menu.selectedUnit === true && backup && (backup.currentStage < backup.totalImportingStages)}
               />
            ))}
         </div>
      </div>
   );
}